/**
 * The key the app's top-level RouterView remounts on. By default that's the whole URL, so every navigation starts the
 * page afresh. A route can opt out with `meta.viewKey`: routes sharing one stay mounted while moving between them,
 * so a page that keeps its own state in the query (search, grouping, tabs) isn't rebuilt on every change of it.
 */
export function viewKey(route) {
    return route.meta?.viewKey ?? route.fullPath;
}
